import loadable from '@loadable/component';

export const FloorPlanLoadable = loadable(() => import('./FloorPlan'));
